<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <i18n path="contacts.addModal.success">
                    <b>{{ addedContact.alias }}<small class="text-muted">(#{{addedContact.id}})</small></b>
                </i18n>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-10 offset-md-1">
                <router-link class="btn btn-primary btn-block" :to="{ name: 'ContactList' }">
                    {{$t('global.modal.ok')}}
                </router-link>
            </div>
        </div>
    </div>
</template>


<script>
import {mapGetters} from 'vuex';

export default {
    computed: mapGetters({
        addedContact: 'contact/pair/addedContact',
    }),
};
</script>


// WEBPACK FOOTER //
// src/components/contact/PairSuccess.vue